const $$splitComponentImporter = () => import('/home/runner/work/graph-it/graph-it/apps/graphit/src/routes/_authed/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { setUser } from '@sentry/react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { authQueryOptions } from '~/queries/auth';
import { cartographiesQueryOptions } from '~/queries/cartographies';
import { meQueryOptions } from '~/queries/me';
import { workspacesQueryOptions } from '~/queries/workspaces';
export const Route = createFileRoute('/_authed')({
  beforeLoad: ({
    context,
    location
  }) => {
    const auth = context.queryClient.getQueryData<AuthStatus>(authQueryOptions.queryKey);
    if (!auth?.authenticated) {
      throw redirect({
        to: '/auth/login',
        search: {
          redirect: location.href
        }
      });
    }
  },
  async loader({
    context
  }) {
    const [me] = await Promise.all([context.queryClient.ensureQueryData(meQueryOptions), context.queryClient.ensureQueryData(workspacesQueryOptions), context.queryClient.ensureQueryData(cartographiesQueryOptions)]);
    setUser({
      id: me.id,
      email: me.email
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});